import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function ShippingTypeView({ title, type, countries, value, onChange, price }) {
    const Choice = ComponentRegistry.get("Choice");
    const Price = ComponentRegistry.get("Price");

    const active = type === value.type;
    return (
      <tr>
        <td colSpan="3">
          <input type="radio" checked={active} onChange={() => onChange()} />
          {title}
        </td>
        <td>
          {active && Object.keys(countries).length > 0 ?
            <Choice
              choices={countries}
              placeholder="-- select country --"
              onChange={country => onChange(country)}
              value={value.country}
            /> :
              null
          }
        </td>
        <td>{active ? <Price value={price} /> : null }</td>
        <td />
      </tr>
    );
}

ShippingTypeView.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.shape({
        type: PropTypes.string,
        country: PropTypes.string,
    }),
    countries: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.string), PropTypes.arrayOf(PropTypes.string)]),
    price: PropTypes.string,
    onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Views/ShippingTypeView.jsx